import { create } from 'zustand';
import { creditService } from '../lib/creditService';

interface CreditState {
  credits: number;
  isLoading: boolean;
  transactions: any[];
  error: string | null;
  fetchCredits: (userId: string) => Promise<void>;
  fetchTransactions: (userId: string) => Promise<void>;
  deductCredits: (userId: string, amount: number, description: string, toolType: string) => Promise<boolean>;
}

export const useCreditStore = create<CreditState>((set, get) => ({
  credits: 0,
  isLoading: false,
  transactions: [],
  error: null,
  
  fetchCredits: async (userId: string) => {
    try {
      set({ isLoading: true, error: null });
      const credits = await creditService.getCredits(userId);
      set({ credits, isLoading: false });
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Failed to fetch credits', 
        isLoading: false 
      });
    }
  },
  
  fetchTransactions: async (userId: string) => {
    try {
      set({ isLoading: true, error: null });
      const transactions = await creditService.getTransactions(userId);
      set({ transactions, isLoading: false });
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Failed to fetch transactions', 
        isLoading: false 
      });
    }
  },
  
  deductCredits: async (userId: string, amount: number, description: string, toolType: string) => {
    try {
      set({ isLoading: true, error: null });
      
      const success = await creditService.deductCredits(userId, amount, description, toolType);
      
      if (success) {
        // Update credits after successful deduction
        const credits = await creditService.getCredits(userId);
        set({ credits, isLoading: false });
      } else {
        set({ 
          error: 'Insufficient credits for this operation', 
          isLoading: false 
        });
      }
      
      return success;
    } catch (error) {
      set({ 
        error: error instanceof Error ? error.message : 'Failed to deduct credits', 
        isLoading: false 
      });
      return false;
    }
  }
}));